module.exports = __webpack_public_path__ + "img/paris.804e56c3.png";